'use strict'
import $ from 'jquery';

export default class AnchorSlider {
  constructor () {
    this._bindEvents();
  }

  _bindEvents () {
    $("body").on("click", ".js_anchorSlide-goTo", (event) => {
      event.stopPropagation();
      event.preventDefault();

      const href = $(event.target).attr("href");
      const offset = $(event.target).data("jsAnchorSlideOffset");
      if (href.indexOf("#") != -1) {
        let $href = $("#"+href.split("#")[1]);
        if ($href.length > 0 && $href.is(":visible")) {
          this._goTo($href, offset);
          // window.location.hash = href;

        }
      }
    });
  }

  _goTo ($href, offset) {
    offset = offset || 0;

    $("html, body").animate({ scrollTop: $href.offset().top + (offset) }, 500);
  }

  scrollTo ($elm, offset) {
    this._goTo($elm, offset)
  }
}



// WEBPACK FOOTER //
// ./fe/web-prefa/src/js/components/AnchorSlider.js